'use client';

import { useMemo, useState } from 'react';
import classNames from 'classnames';
import { Button } from '@/features/button';
import SafeHtml from '@/components/safe-html';
interface Props {
  content: string;
  className?: string;
  contentClassName?: string;
  onlyShowH1?: boolean;
}
export default function ExpandableText({
  content,
  className,
  contentClassName,
  onlyShowH1
}: Props) {
  const [isShowFullContent, setIsShowFullContent] = useState(false);
  const isTextOverflow = useMemo(() => content.length >= 400, [content]);
  const isCollapsed = !isShowFullContent && isTextOverflow;
  function handleClick() {
    setIsShowFullContent(!isShowFullContent);
  }
  return <div className='homepage-container' data-sentry-component="ExpandableText" data-sentry-source-file="expandable-text.tsx">
            <div className='relative h-auto w-full overflow-hidden whitespace-normal'>
                {onlyShowH1 ? <h1 className='text-body-14 font-bold lg:text-body-16'>بلک فرایدی</h1> : <>
                        <div className={classNames(className, {
          'line-clamp-4 max-h-20 overflow-hidden text-ellipsis lg:max-h-26': isCollapsed
        })}>
                            <SafeHtml content={content} className={contentClassName} />
                        </div>
                        {isCollapsed && <div className='absolute right-0 top-0 h-full w-full bg-gradient-to-t from-[var(--landing-bg)] to-transparent' />}
                    </>}
            </div>
            <Button size='medium' graphicStyle='text' className={!isTextOverflow ? 'hidden' : 'mx-auto'} onClick={() => handleClick()} data-sentry-element="Button" data-sentry-source-file="expandable-text.tsx">
                {isShowFullContent ? 'بستن' : 'مشاهده بیشتر'}
            </Button>
        </div>;
}